import { Offer } from 'gql/autogen/Offer';
import { BookingRequirement } from 'gql/autogen/BookingRequirement';
import { PaxRequirement } from 'gql/autogen/PaxRequirement';
import { Pax } from 'gql/autogen/Pax';
import { EnrichedOfferOption } from 'gql/autogen/EnrichedOfferOption';
import { Specification } from 'gql/autogen/Specification';

export interface SelectedOfferState {
    offer?: Offer;
    offerIndex?: number;
}

export interface BookingRequirementState {
    bookingRequirementId: number;
    isResetSearchCriteriaStatus: boolean;
}

export interface EnrichedBookingRequirement extends Pick<BookingRequirement, 'id' | 'adultRequired' | 'minPax' | 'maxPax'> {
    paxRequirements: PaxRequirement[];
}

export interface SelectedOfferCard {
    isSelectedOfferCardExist: boolean;
    selectedOfferCardIndex: number;
}

export enum OfferNotificationType {
    DateChip = 'DateChip',
    OptionSpec = 'OptionSpec',
}

export enum ContinueYourBookingNotificationType {
    OfferNotAvailable = 'OfferNotAvailable',
    DateNotAvailable = 'DateNotAvailable',
}
export type OfferOptionsState = Record<
    number,
    {
        passengers: Pax[];
        selectedDate?: Date;
        offerOptionId?: number;
        possibleOfferOptions?: EnrichedOfferOption[];
        allOfferOptions?: EnrichedOfferOption[];
        selectedSpecifications?: Specification[];
        basedCalendarOfferIds?: (number | undefined)[];
        isCartEligible?: boolean;
        unavailableDatesFromAvailabilityResponse?: Date[];
        firstLandingOfferSelected?: boolean;
    }
>;
